/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {AbpsBoardService} from './abps-board.service';

@NgModule({
    providers: [
        AbpsBoardService
    ]
})
export class AbpsBoardModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/abps/abps-board.module.ts